export default __webpack_public_path__ + "images/4_2_image.jpg";